import Image from 'next/image';
import { useTranslations } from "next-intl";
import emptyImg from '@/features/notifications/images/no-record.png';

interface EmptyProps {
  showText?: boolean;
}

export default function Empty({ showText = false }: EmptyProps) {
  const t = useTranslations('notifications');

  return (
    <div className="flex mt-[170px] justify-center items-center flex-col">
      <Image src={emptyImg} alt="" className="w-[57px] h-[61px] m-[10px]" />
      {showText && (
        <div className="text-[14px] text-tertiary font-medium mt-[10px]">{t('empty')}</div>
      )}
    </div>
  );
}